import { render } from "./PasswordRecoveryView.vue?vue&type=template&id=52312b57"
import script from "./PasswordRecoveryView.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__